export const PROPOSAL_DESCRIPTION_UNAVAILABLE = 'Description unavailable';

export const LAST_ACTIVE_STRATEGIC_OFFER_MESSAGE =
  'Shopper is live and this is its only active strategic offer. Add or activate another strategic offer before deleting this one.';
